/* @flow */

import type { ResponseInterceptorType } from 'lib/ResponseInterceptors';

const registeredInterceptors: Map<string, ResponseInterceptorType> = new Map();

export function registerInterceptor(name: string, interceptor: ResponseInterceptorType): void {
  if (registeredInterceptors.has(name)) {
    throw new Error(`interceptor name ${name} already registered`);
  }
  registeredInterceptors.set(name, interceptor);
}

export function unregisterInterceptor(name: string): void {
  registeredInterceptors.delete(name);
}

export const checkInterception = (response: Object, endpoint: string) => {
  const interceptors = Array.from(registeredInterceptors.values());
  return interceptors.some(interceptor => interceptor(response, endpoint));
};
